// extracted by mini-css-extract-plugin
export var accent = "_83-4";
export var add = "_83-j";
export var addIcon = "_83-k";
export var deleteIcon = "_83-i";
export var disabled = "_83-9";
export var ellipsis = "_83-f";
export var error = "_83-3";
export var form = "_83-5";
export var hideFocus = "_83-2";
export var icon = "_83-7";
export var input = "_83-e";
export var listItem = "_83-h";
export var mediumHeight = "_83-b";
export var noBorder = "_83-8";
export var noRadius = "_83-1";
export var shortHeight = "_83-a";
export var tallHeight = "_83-c";
export var textInput = "_83-0";
export var vertical = "_83-g";
export var veryTallHeight = "_83-d";
export var widget = "_83-6";